import { emptyArray2Undefined, optional, tryMapNew, tryNew } from '@/helpers/dto2resource';

import DetalheOfertaDto from '../dto/DetalheOfertaDto';
import ContaBancariaResource from './ContaBancariaResource';
import LimitesResource from './LimitesResource';
import ParcelaNegociadaDividaResource from './ParcelaNegociadaDividaResource';
import TaxasEJurosResource from './TaxasEJurosResource';
import ValoresOpcaoPagamentoResource from './ValoresOpcaoPagamentoResource';

class DetalheOfertaResource {
  taxasEJuros?: TaxasEJurosResource;
  contasBancarias?: ContaBancariaResource[];
  parcelasNegociadasDivida?: ParcelaNegociadaDividaResource[];
  urlTermoCondicoesGerais?: string;
  valores?: ValoresOpcaoPagamentoResource;
  datasPrimeiroPagamento?: Date[];
  limites?: LimitesResource;
  desenrola?: boolean;
  simulacaoComFgts?: boolean;
  liquidacao?: boolean;
  valorFgts?: number;
  giftCardElegivel?: boolean;

  constructor(dto: DetalheOfertaDto) {
    this.taxasEJuros = tryNew(TaxasEJurosResource, dto.taxasEJuros);
    this.contasBancarias = tryMapNew(ContaBancariaResource, dto.contasBancarias, { undefinedIfEmpty: true });
    this.parcelasNegociadasDivida = tryMapNew(ParcelaNegociadaDividaResource, dto.parcelasNegociadasDivida, {
      undefinedIfEmpty: true,
    });
    this.urlTermoCondicoesGerais = optional(dto.urlTermoCondicoesGerais);
    this.valores = tryNew(ValoresOpcaoPagamentoResource, dto.valores);
    this.datasPrimeiroPagamento = emptyArray2Undefined(dto.datasPrimeiroPagamento)?.map(d => new Date(d));
    this.limites = tryNew(LimitesResource, dto.limites);
    this.desenrola = optional(dto.desenrola);
    this.simulacaoComFgts = optional(dto.simulacaoComFgts);
    this.liquidacao = optional(dto.liquidacao);
    this.valorFgts = optional(dto.valorFgts);
    this.giftCardElegivel = optional(dto.giftCardElegivel);
  }
}

export default DetalheOfertaResource;
